<template>
  <div>
    <v-container
      fluid
      class="pa-0 info-drawer"
    >
      <div class="pa-6">
        <h2 class="d-flex justify-space-between align center mb-1">
          Manage Contact Tags
          <v-btn
            icon
            @click.stop="$store.commit('ui/drawer.right.toggle')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </h2>
        <v-row>
          <v-col
            cols="12"
            class="body-2 pt-3 grey--text text--darken-2 font-weight-medium mb-3 text-left"
          >
            Select the available tags to associate the customer with that tag.
          </v-col>
        </v-row>
        <v-btn
          outlined
          :loading="loading"
          @click.stop="updateTags"
        >
          SAVE
        </v-btn>
      </div>

          <v-text-field
            v-model="searchString"
            outlined
            class="pa-6 pb-0 text--grey"
            label="Search"
            prepend-inner-icon="search"
          />
          <div class="pa-6 pt-0 list-frame">
            <v-list
              subheader
              two-line
              flat
            >
              <div class="body-2 strike-not-through grey--text text--darken-2 text-left pl-5">
                <span class="white">  Selected Tags ({{ filterItems(tagsList).length }})</span>
              </div>
              <div class = "strike-not-through grey--text text--darken-2 text-left pl-5 py-5"
              v-if ="!tagsList.length">No Selections</div>
              <v-list-item-group
                multiple
              >
                <v-list-item
                  v-for="list in filterItems(tagsList)"
                  :key="list.id"
                  :ripple="false"
                  class="pa-0"
                >
                  <template v-slot:default="{ }">
                    <v-list-item-action class="mr-2">
                      <v-icon
                        color="#03B6FC"
                        @click="update_tags(list, false)"
                      >
                        mdi-checkbox-marked
                      </v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>{{ list.name }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>

           <v-list
              subheader
              two-line
              flat
            >
              <div class="body-2 strike-not-through grey--text text--darken-2 text-left pl-5">
                <span class="white">  Unselected Tags ({{ totalListCountStatic - tagsList.length }})</span>
              </div>
              <div class = "strike-not-through grey--text text--darken-2 text-left pl-5 py-5"
              v-if ="totalListCountStatic - tagsList.length == 0">No Tags Available</div>
              <template v-if="loading == true">
                <v-overlay
                  :value="loading"
                  opacity="0.2"
                >
                  <v-progress-circular
                    indeterminate
                    size="64"
                  />
                </v-overlay>
              </template>
              <v-list-item-group>
                <v-list-item
                  v-for="list in allTags"
                  :key="list.id"
                  class="pa-0"
                  :ripple="false"
                >
                  <template>
                    <v-list-item-action
                      class="mr-2"
                    >
                      <v-icon
                        color="grey"
                        @click="update_tags(list, true)"
                      >
                        mdi-checkbox-blank-outline
                      </v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>{{ list.name }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
                <v-list-item
                  v-if="totalListCount != 0 && totalListCount !== (allTags.length + tagsList.length)"
                  :ripple="false"
                  class="d-flex justify-center"
                >
                  <v-btn
                    outlined
                    @click="getAllTags(true)"
                  >
                    Show More
                  </v-btn>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>
    </v-container>
  </div>
</template>
<script>
  import commonFunctions from '@core/helpers/commonFunctions'
  import { $marketingContacts } from "@core/services"

  export default {
    data () {
      return {
        contactId: null,
        allSelected: false,
        currentPage: 1,
        defaultValueTrue: true,
        defaultValueFalse: false,
        loading: false,
        totalListCount: 0,
        totalListCountStatic: 0,
        searchString: '',
        tagsList: [],
        allTags: [],
      }
    },
    watch: {
      searchString: commonFunctions._debounce(function () {
        this.currentPage = 1
        this.getAllTags()
      }, 700),
    },
    mounted () {
      this.contactId = this.$route.params.contactId
      this.getSelectedTagsLists()
    },
    methods: {
      getSelectedTagsLists () {
        this.loading = true
        $marketingContacts.getContactsTags(this.contactId).then(response => {
          this.tagsList = response.data.tags
          this.getAllTags()
        }).catch(error => {
          console.error('Error', error)
        })
      },
      filterItems (presets) {
        return presets.filter(preset => {
          const regex = new RegExp('(' + this.searchString + ')', 'i')
          return preset.name.match(regex)
        })
      },
      update_tags (list, add) {
        let index
        if (add) {
          index = this.allTags.findIndex(x => x.id === list.id)
          this.tagsList.push(
            ...this.allTags.splice(
              index < 0 ? 0 : index,
              index < 0 ? this.allTags.length : 1,
            ),
          )
        } else {
          index = this.tagsList.findIndex(x => x.id === list.id)
          if (index < 0) {
            this.tagsList = []
            this.currentPage = 1
          } else {
            this.allTags.unshift(...this.tagsList.splice(index, 1))
          }
        }
        if (index < 0) this.getAllTags(add)
      },
      updateTags () {
        this.loading = true
        $marketingContacts.updateTags(this.contactId, {
          tags: this.tagsList.map(x => {
            return x.id
          })
        }).then(response => {
          this.$store.commit('ui/snackbar', { message: 'Updating tags process just started', type: 'success' })
          this.currentPage = 1
          this.$store.commit('ui/drawer.right', {
            show: false,
            component: null,
            response: { tagsList: JSON.parse(JSON.stringify(this.tagsList)) },
          })
        }).catch(error => {
          console.error('Error', error)
        }).finally(() => {
          this.loading = false
        })
      },
      getAllTags (showMore) {
        this.loading = true
        const perPage = 10
        $marketingContacts.getAllTags({
          params: {
            page: showMore ? ++this.currentPage : this.currentPage,
            per_page: perPage,
            name: this.searchString,
          },
        }).then(response => {
          if (!this.searchString) { this.totalListCountStatic = response.data.meta.total_count }
          this.totalListCount = response.data.meta.total_count
          // filter for common data
          this.tagsList.map(tagsList => {
            response.data.data.map((tag, index) => {
              if (tagsList.id === tag.id) {
                response.data.data.splice(index, 1)
              }
            })
          })

          // push in the array if show more is clicked
          if (showMore) {
            this.allTags.push(...response.data.data)
          } else this.allTags = response.data.data

          // call function recursively if all matched and spliced off
          if (
            !response.data.data.length &&
            this.totalListCount > this.currentPage * perPage
          ) {
            this.getAllTags(true)
          }
        }).catch(error => {

        }).finally(() => {
          this.loading = false
        })
      },
    },
  }
</script>
